import { Trophy } from "lucide-react";
import { bg } from "../lib/api";
import { PRIZES } from "./Hero";

const note = (data) => {
  if (!data.config.showResults && data.isAdmin) return "Solo tú estás viendo el ranking (oculto para los demás).";
  return data.config.votingOpen ? "Ranking en vivo — puede cambiar hasta que cierre la votación (viernes 6 de noviembre, 12:00 CDMX)." : "Votación cerrada. Resultado final.";
};

export const Results = ({ data, onOpen }) => {
  if (!data) return <section className="on"><h2>Resultados</h2></section>;
  const n = data.entries.length, v = data.voters;
  return (
    <section className="on" data-testid="results-section">
      <h2>Resultados</h2>
      <p className="meta" data-testid="results-meta">
        {n} {n === 1 ? "león" : "leones"} · {v} {v === 1 ? "persona ha votado" : "personas han votado"}
      </p>
      {!data.results ? (
        <div className="banner" data-testid="results-hidden-note">Los resultados se publicarán al cierre del concurso.</div>
      ) : (
        <>
          <div className="banner" data-testid="results-note">{note(data)}</div>
          <ol className="rank" data-testid="results-ranking">
            {!n && <li className="empty" style={{ display: "block" }}>Todavía no hay participantes.</li>}
            {data.results.map((e, i) => {
              const top = i === 0 && e.pts > 0;
              return (
                <li key={e.id} className={top ? "top" : ""} data-testid={`rank-row-${i + 1}`}>
                  <div className="pos">{top ? <Trophy size={26} /> : i + 1}</div>
                  <button className="th" style={bg(e.photoId)} aria-label="Ver foto" onClick={() => onOpen(e)} />
                  <div>
                    <div className="nm">{e.name}</div>
                    <div className="br">1º×{e.first} · 2º×{e.second} · 3º×{e.third}{e.lionName ? ` · «${e.lionName}»` : ""}</div>
                  </div>
                  <div className="pts" data-testid={`rank-points-${i + 1}`}>{e.pts}<small>puntos</small>
                    {i < 3 && e.pts > 0 && <span className="rprize" data-testid={`rank-prize-${i + 1}`}>{PRIZES[i]} MXN</span>}
                  </div>
                </li>
              );
            })}
          </ol>
        </>
      )}
    </section>
  );
};
